<template>
<el-menu
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      background-color="#2d3a4b"
      text-color="#fff"
      router
      v-model="indexPath"
      active-text-color="#ffd04b"
      ref="submenu"
      :default-openeds="defaultOpens"
      :unique-opened="true"
      >
      <el-menu-item index="/" @click.native="openTab({name:'首页',path:'/'})" ref="homeMenu">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </el-menu-item>
      <!-- eslint-disable -->
      <el-submenu :index="menu.path" v-for="menu in menuList">
        <template #title>
          <i :class="menu.icon"></i>
          <span>{{menu.name}}</span>
        </template>
        <el-menu-item :index="item.path" v-for="item in menu.children" @click.native="openTab(item)">
            <i :class="item.icon"></i>
            {{item.name}}
        </el-menu-item>
      </el-submenu>
    </el-menu>
</template>

<script>
/* eslint-disable */
import router from '@/router';
import store from '@/store';


export default {
    name: "MenuView",
    data(){
        return {
            menuList:[],
            indexPath:'',
            defaultOpens:[],
            defaultActive:'/'
        }
    },
    mounted(){
        this.menuList = JSON.parse(window.sessionStorage.getItem('menuList'))
        if (this.$store.state.edittableTabsValue != null) this.defaultActive = this.$store.state.edittableTabsValue
        if (this.$store.state.edittableTabsValue == '/index') this.defaultActive = '/'
    },
    methods:{
        openTab(item){
            store.commit('ADD_TABS',item)
        },
    },
    watch:{
            $route(to){
                if (to.path == '/index')this.defaultActive = '/'
                else{
                    this.defaultActive = to.path
                }
                
            },

        },
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo {
    text-align: left;
    position: sticky;
}
</style>